import { Box } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { EditIcon2 } from "../../../../../assets/images/icons/EditIcon2";
import BriaButton from "../../../../../components/common/BriaButton/BriaButton";
import BriaButtonGroup from "../../../../../components/common/BriaButtonGroup/BriaButtonGroup";
import { useAppStore } from "../../../../../hooks/useStores";
import { VideoEditingResolution } from "../../../../../models/video-editing";
import styles from "./VideoIncreaseResConfig.module.scss";

const VideoIncreaseResConfig = () => {
	const { videoEditingStore } = useAppStore();
	const { t } = useTranslation("video_editing", { keyPrefix: "lab.config.tools.increase_resolution.config" });

	const handleScaleChange = (scale?: VideoEditingResolution) => {
		videoEditingStore.handleConfigChange("tool_config", {
			...videoEditingStore.config.tool_config,
			increase_resolution: {
				desired_increase: scale,
			},
		});
	};

	const desiredIncrease = videoEditingStore.config.tool_config?.increase_resolution?.desired_increase;

	const ScaleButton = ({ scale }: { scale: VideoEditingResolution }) => (
		<BriaButton
			buttonType="textSmall"
			className={clsx(styles.scaleButton, { [styles.selected]: scale === desiredIncrease })}
			onClick={() => handleScaleChange(scale)}
		>
			{t(scale)}
		</BriaButton>
	);

	const ScaleAppliedComponent = ({ scale }: { scale: VideoEditingResolution }) => (
		<>
			<Box className={styles.description}>{t("hasScaleDescription", { scale: t(scale) })}</Box>
			<BriaButtonGroup>
				<EditIcon2 onClick={() => handleScaleChange(undefined)} className={styles.iconButton} />
				<ScaleButton scale={scale} />
			</BriaButtonGroup>
		</>
	);

	return (
		<Box className={styles.container}>
			{desiredIncrease ? (
				<ScaleAppliedComponent scale={desiredIncrease} />
			) : (
				<>
					<Box className={styles.description}>{t("description")}</Box>
					<BriaButtonGroup>
						<ScaleButton scale="2" />
						<ScaleButton scale="4" />
					</BriaButtonGroup>
				</>
			)}
		</Box>
	);
};

export default observer(VideoIncreaseResConfig);
